<template>
    <div class="contact-info">
        <div class="contact-info__inner container flex j_sb">
            <div class="contact-info__col flex wc-lg" v-for="(col, index) in content" :key="index">
                <router-link :to="_.get(col, 'link')" class="contact-info__col--inner flex j_sb" v-if="index == 2">
                    <div class="editor" v-html="_.get(col, 'content')"></div>
                    <div v-html="_.get(col, 'link_name')"></div>
                </router-link>
                <div class="contact-info__col--inner" v-html="_.get(col, 'content')" v-else></div>
            </div>
            <div class="contact-info__col flex wc-lg contact-info_locations">
                <h4 class="ttl">{{ $fn.tr("ლოკაციები") }}</h4>
                <div class="links">
                    <a v-for="location in locations" :href="location.url" class="link"
                        :target="location.targetblank ? '_blank' : '_self'" :key="location.slug">
                        {{ location.title }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['contentData'],
    mounted() {
        console.log(this.contentData)
    },
    computed: {
        content() {
            return _.get(this.contentData, 'data.list[0].content.tabs');
        },
        locations() {
            return this.$store.state.main.indx.widgets.locations
        }
    }
}
</script>
<style lang="scss" scoped>
.contact-info__col:nth-child(2) {
    &::v-deep {

        h2,
        strong {

            font-family: "TBCSailec-Bold";

            font-size: 18px;
            line-height: 24px;
        }
    }
}

.contact-info_locations {
    display: flex;
    flex-direction: column;

    .ttl {
        font-family: "TBCSailec-Bold";
        font-size: 18px;
        line-height: 24px;
        color: #7063e9;
    }

    .link{
        transition: .4s;
        &:hover{
            color: #7063e9;
        }
    }

    .links{
        display: flex;
        flex-direction: column;
        margin-top: 21px;
    }
}</style>
